AudioContext.prototype.decodeAudioDataAsync = function decodeAudioDataAsync(
	data
) {
	return new Promise((resolve, reject) => {
		this.decodeAudioData(data, resolve, reject);
	});
};
